import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import SectionHeader from '@/components/SectionHeader';
import Spinner from '@/components/Spinner';
import { API } from '@/lib/utils';
import { useSEO } from '@/lib/useSEO';
import { ArrowRight } from '@phosphor-icons/react';

export default function CategoriesList() {
  const [categories, setCategories] = useState(null);

  useSEO({
    title: 'Alle productcategorieën',
    description: 'Blader door alle categorieën van een noodpakket: water & voedsel, EHBO, verlichting, communicatie, warmte, gereedschap, hygiëne en documenten.',
    path: '/categorieen',
  });

  useEffect(() => {
    axios.get(`${API}/categories`).then((r) => setCategories(Array.isArray(r.data) ? r.data : [])).catch(console.error);
  }, []);

  return (
    <div data-testid="page-categories">
      <section className="border-b border-border bg-card">
        <div className="container py-16 lg:py-24">
          <SectionHeader
            eyebrow="Categorieën"
            title="Blader op productsoort"
            description="Water, EHBO, verlichting, gereedschap — alle productgroepen in één overzicht."
            accent
          />
        </div>
      </section>
      <section className="container py-12 lg:py-16">
        {categories === null ? <Spinner /> : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {(categories || []).map((c) => (
              <Link
                key={c.slug}
                to={`/categorieen/${c.slug}`}
                data-testid={`cat-${c.slug}`}
                className="group bg-card border border-border hover:border-primary p-8 rounded-sm transition-colors relative overflow-hidden"
              >
                <div className="overline text-muted-foreground mb-3">Categorie</div>
                <h3 className="font-display font-black text-2xl leading-tight mb-3 group-hover:text-primary transition-colors">{c.name}</h3>
                <p className="text-sm text-muted-foreground">{c.description}</p>
                <div className="mt-6 text-primary font-semibold inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                  Bekijk producten <ArrowRight size={16} weight="bold" />
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
